import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import {Delete, OpenWith} from '@mui/icons-material'
import CellValue from 'components/CellValue'
import {fieldtype} from 'utils/enums/fieldtype'

const OpenIcon = styled(OpenWith)`
    padding-right: 20px;
    cursor: pointer;
    color: #a0b7be;
`

const DeleteIcon = styled(Delete)`
    padding-left: 20px;
    color: #d45b4a;
    cursor: pointer;
`

const Container = styled.div`
    box-sizing: border-box;
    min-height: 70px;
    align-items: center;
    padding: 0 20px;
    display: flex;
    border: none;
    margin: 0;
    box-shadow: 0 1px 3px 0 rgba(179, 216, 225, .5);
    background: ${props => props.error ? 'rgba(212, 91, 74, 0.25)' : '#FFF'};
`

const Label = styled.input`
    padding: 0;
`

const Name = styled.span`
    font-weight: 700;
    font-size: 10px;
    margin-bottom: 5px;
`

const Option = styled.div`
    text-transform: uppercase;
    padding: 4px 10px;
    font-size: 10px;
    background-color: ${props => props.active ? '#415dd4' : 'rgba(160, 183, 190, .24)'};
    color: ${props => props.active ? '#fff' : '#7c9198'};
    cursor: pointer;
    margin-top: 5px;
    display: inline-block;
    border-radius: 2px;
    letter-spacing: 1px;

    :not(:last-child) {
        margin-right: 5px;
    }
`

const Block = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 7px 0;
    box-sizing: border-box;
    justify-content: flex-end;
    margin-right: 50px;
`

const Value = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    height: 45px;
    line-height: 45px;
`

const Field = styled.div`
    border-top-right-radius: 2px;
    border-top-left-radius: 2px;
    background-color: rgba(160, 183, 190, 0.24);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    min-width: 230px;
`

class Item extends React.Component {
    handleChange = (e) => {
        this.props.handleChange(e.target.value, e.target.name, this.props.id)
    }

    handleClick = (name) => {
		const value = name === 'autocomplete' && this.props[name] ? null : !this.props[name]
        this.props.handleChange(value, name, this.props.id)
    }

    handleUpdate = (value) => {
        this.props.handleChange(value || value === 0 ? value : true, 'autocomplete', this.props.id)
    }

    getDefaultValue = () => {
        if (this.props.type === fieldtype.linkedfield) {
			if (this.props.values && this.props.autocomplete.length) {
				const defaultValue = this.props.values.find(item => item.id === this.props.autocomplete[0])

            	return defaultValue ? defaultValue.name : undefined
			} else {
				return undefined
			}
        } else {
            return this.props.autocomplete
        }
    }

    onDragStart = (e) => {
        e.preventDefault()
        e.stopPropagation()

        this.props.onDragStart(e, this.props.id)
    }

    render() {
        const { intl, config, type, id, options } = this.props
        const rules = type ? options[type.toLowerCase()] : null
		const autocomplete = this.props.autocomplete || this.props.autocomplete === 0
        const defaultValue = autocomplete && this.props.autocomplete !== true ? this.getDefaultValue() : undefined

        return (
            <Container
                data-drag-field={id}
                draggable={true}
                onDragStart={this.onDragStart}
            >
                <OpenIcon style={{ fontSize: 20, cursor: 'grab' }} />
                <Block>
                    {this.props.subtitle ?
                        <Label data-field={id}
                            onBlur={e => e.target.value ? this.handleChange(e) : e.target.value = this.props.subtitle}
                            name='subtitle'
                            defaultValue={this.props.subtitle}
                            style={{fontSize: '16px'}}
                        /> :
                        <React.Fragment>
                            {!this.props.label || this.props.label === this.props.name ?
                                <Label data-field={id}
                                    onBlur={this.handleChange}
                                    name='label'
                                    defaultValue={this.props.name}
                                    maxLength={global.LONG_NAME_MAX_LENGTH}
                                /> :
                                <React.Fragment>
                                    <Name>{this.props.name}</Name>
                                    <Label onBlur={this.handleChange}
                                        name='label'
                                        defaultValue={this.props.label}
                                        maxLength={global.LONG_NAME_MAX_LENGTH}
                                    />
                                </React.Fragment>
                            }
                        </React.Fragment>
                    }
                    {!this.props.subtitle &&
                        <div style={{minHeight: '24px'}}>
                            {Object.keys(rules).map((item, index) =>
                                rules[item] &&
                                <Option key={index}
                                    active={this.props[item] || this.props[item] === 0 ? true : false}
                                    name={item}
                                    onClick={() => this.handleClick(item)}
                                >
                                    {intl.formatMessage({id: `sidebar.${item}`})}
                                </Option>
                            )}
                        </div>
                    }
                </Block>
                {autocomplete &&
                    <Field>
                        <Value>
                            <CellValue
                                config={config}
                                type={type}
                                defaultValue={defaultValue}
                                linkedRelation={this.props.autocomplete === true ? null : this.props.autocomplete}
                                name={id}
                                title={this.props.name}
                                handleUpdateValue={this.handleUpdate}
                                disableCreate={true}
                            />
                        </Value>
                    </Field>
                }
                <DeleteIcon onClick={() => this.props.deleteField(id)} style={{ fontSize: 25 }} />
            </Container>
        )
    }
}

export default injectIntl(Item)
